/**
 * Format a Date as YYYYMMDD (no separators).
 * Used across document generation payloads (DA7923, DD200, DD1149, etc.).
 */
export const toYYYYMMDD = (date: Date = new Date()): string => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}${mm}${dd}`;
};

/**
 * Normalizes a date string so that bare YYYY-MM-DD values are treated as local
 * midnight rather than UTC midnight. Without the time component, `new Date()`
 * parses ISO date-only strings as UTC, which shifts the date by the local
 * timezone offset and causes off-by-one-day errors in filtering and display.
 */
export const normalizeDateString = (value: string): string =>
  /^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T00:00:00` : value;
